import { useCallback, useState } from "react";

import type { Ichinomiya1stSpecialTermsMessages } from "./ichinomiya1st-special-terms";
import { Ichinomiya1stSpecialTerms } from "./ichinomiya1st-special-terms";
import type { Ichinomiya2ndSpecialTermsMessages } from "./ichinomiya2nd-special-terms";
import { Ichinomiya2ndSpecialTerms } from "./ichinomiya2nd-special-terms";

export function useIchinomiyaSpecialTerms(
  siteSlug: string,
  messages?: {
    ichinomiya1st?: Ichinomiya1stSpecialTermsMessages;
    ichinomiya2nd?: Ichinomiya2ndSpecialTermsMessages;
  },
) {
  const [agreed, setAgreed] = useState(false);
  const isSiteOriginalIchinomiya =
    siteSlug === "ichinomiya1st" || siteSlug === "ichinomiya2nd";
  const renderIchinomiyaSpecialTerms = useCallback(() => {
    switch (siteSlug) {
      case "ichinomiya1st":
        return (
          <Ichinomiya1stSpecialTerms
            agreed={agreed}
            setAgreed={setAgreed}
            messages={messages?.ichinomiya1st}
          />
        );
      case "ichinomiya2nd":
        return (
          <Ichinomiya2ndSpecialTerms
            agreed={agreed}
            setAgreed={setAgreed}
            messages={messages?.ichinomiya2nd}
          />
        );
      default:
        return null;
    }
  }, [agreed, setAgreed, siteSlug, messages]);
  return {
    renderIchinomiyaSpecialTerms,
    agreedOrUnnecessary: agreed || !isSiteOriginalIchinomiya,
  };
}
